const sliders =  {
    _sliderObjects: [],

    init() {
        if(document.querySelectorAll('.swiper') === 0) {
            return;
        }

        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        const cssUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

        window.initPackages([scriptUrl, cssUrl]).then(() => {
            self._constructSliders();
        }).catch((error) => {
            console.error(error);
        });

    },

    reInit() {
        let self = this;
        if(self._sliderObjects.length > 0) {
            self._sliderObjects.forEach(slider => {
                slider.destroy();
            });

            self._sliderObjects = [];
        }
        self.init();
    },

    _constructSliders() {
        let self = this;
        let headerSlider = document.querySelector('.js-header-slider');
        let bannerSliders = document.querySelectorAll('.js-banner-slider');
        let heroSliders = document.querySelectorAll('.js-hero-slider');

        if(headerSlider) {
            self._buildHeaderSlider(headerSlider);
        }

        if(bannerSliders.length > 0) {
            self._buildBannerSliders(bannerSliders);
        }

        if(heroSliders.length > 0) {
            self._buildHeroSliders(heroSliders);
        }
    },

    _buildHeaderSlider(headerSlider) {
        let self = this;

        let slider = new Swiper(headerSlider, {
            loop: true,
            effect: 'slide',
            autoplay: {
                enabled: false,
            },
            speed: 800,
            pagination: {
                el: ".js-header-slider__pagination",
                clickable:true
            },
            breakpoints: {
                992: {
                    autoplay: {
                        enabled: true,
                        delay: 10000,
                        pauseOnMouseEnter: true,
                    }
                },
            }
        });

        self._sliderObjects.push(slider);
    },

    _buildBannerSliders(bannerSliders) {
        let self = this;

        bannerSliders.forEach((bannerSlider, index) => {
            let slider = new Swiper(bannerSlider, {
                slidesPerView: 2,
                spaceBetween: 24,
                rewind: true,
                autoplay: {
                    delay: 5000,
                },
                breakpoints:{
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 6,
                    }
                },
                loop: true,
                pagination: {
                    el: ".js-banner-slider__pagination",
                    clickable:true
                },
            });

            self._sliderObjects.push(slider);
        });
    },

    _buildHeroSliders(heroSliders) {
        let self = this;

        heroSliders.forEach(heroSlider => {
            let slider = new Swiper(heroSlider, {
                loop: true,
                effect: 'slide',
                spaceBetween: 40,
                autoplay: {
                    delay: 10000,
                    pauseOnMouseEnter: true,
                },
                speed: 800,
                pagination: {
                    el: ".js-hero-slider__pagination",
                    clickable:true
                },
                navigation: {
                    nextEl: '.js-hero-slider__next',
                    prevEl: '.js-hero-slider__prev',
                },
            });

            self._sliderObjects.push(slider);
        });

    },
}

sliders.init();
document.addEventListener('LokiRequestEnd', function () {
    sliders.reInit();
});
